const BACKEND = 'https://kikomo-mayoreo-backend.vercel.app';
const API_KEY = 'e8bfe89e44b84c056ee64fa6c6f2fdc2';

let currentVendor = null;
let pendingEmail = null;
let allClientes = [];
let filteredClientes = [];
let allProductos = [];
let filteredProductos = [];
let currentPage = 1;
let totalPages = 1;
let carrito = [];
let currentCliente = null;

function saveSession(vendor) {
  var session = { vendor: vendor, expiry: Date.now() + 10 * 24 * 60 * 60 * 1000 };
  localStorage.setItem('kikomo_session', JSON.stringify(session));
}

function loadSession() {
  try {
    var raw = localStorage.getItem('kikomo_session');
    if (!raw) return null;
    var session = JSON.parse(raw);
    if (Date.now() > session.expiry) { localStorage.removeItem('kikomo_session'); return null; }
    return session.vendor;
  } catch(e) { return null; }
}

function clearSession() { localStorage.removeItem('kikomo_session'); }

function showLoading(msg) { document.getElementById('loading-msg').textContent = msg || 'Cargando...'; document.getElementById('loading').classList.add('visible'); }
function hideLoading() { document.getElementById('loading').classList.remove('visible'); }
function showScreen(id) { document.querySelectorAll('.screen').forEach(function(s) { s.classList.remove('active'); }); document.getElementById(id).classList.add('active'); }
function showView(id) { document.querySelectorAll('.view').forEach(function(v) { v.classList.remove('active'); }); document.getElementById(id).classList.add('active'); }
function fmt(n) { return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(n); }
function genFolio() { var d = new Date(); function pad(n) { return String(n).padStart(2,'0'); } return 'KIK-' + d.getFullYear() + pad(d.getMonth()+1) + pad(d.getDate()) + '-' + Math.floor(Math.random()*9000+1000); }
function initials(name) { return name.split(' ').slice(0,2).map(function(w) { return w[0]; }).join('').toUpperCase(); }

document.addEventListener('DOMContentLoaded', function() {
  var savedVendor = loadSession();
  if (savedVendor) {
    currentVendor = savedVendor;
    document.getElementById('topbar-name').textContent = currentVendor.firstName + ' ' + currentVendor.lastName;
    showScreen('screen-app');
    showView('view-clientes');
    loadClientes();
  }
  var codeInput = document.getElementById('login-code');
  if (codeInput) {
    codeInput.addEventListener('keydown', function(e) { if(e.key === 'Enter') doVerify(); });
  }
});

async function doLogin() {
  var email = document.getElementById('login-email').value.trim();
  var err = document.getElementById('login-error');
  var btn = document.getElementById('btn-login');
  err.classList.remove('visible');
  if (!email) { err.textContent = 'Ingresa tu correo.'; err.classList.add('visible'); return; }
  btn.disabled = true;
  btn.textContent = 'Enviando...';
  try {
    var res = await fetch(BACKEND + '/api/send-code', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({_key: API_KEY, email: email })
    });
    var data = await res.json();
    if (!res.ok) throw new Error(data.error);
    pendingEmail = email;
    document.getElementById('login-email').value = '';
    document.getElementById('login-step-1').style.display = 'none';
    document.getElementById('login-step-2').style.display = 'block';
    document.getElementById('login-greeting').textContent = 'Hola ' + data.name + ', revisa tu correo';
  } catch(e) {
    err.textContent = e.message || 'Error al enviar el codigo.';
    err.classList.add('visible');
    btn.disabled = false;
    btn.textContent = 'Enviar codigo';
  }
}

async function doVerify() {
  var code = document.getElementById('login-code').value.trim();
  var err = document.getElementById('login-error');
  var btn = document.getElementById('btn-verify');
  err.classList.remove('visible');
  if (!code) { err.textContent = 'Ingresa el codigo.'; err.classList.add('visible'); return; }
  btn.disabled = true;
  btn.textContent = 'Verificando...';
  try {
    var res = await fetch(BACKEND + '/api/verify-code', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ _key: API_KEY, email: pendingEmail, code: code })
    });
    var data = await res.json();
    if (!res.ok) throw new Error(data.error);
    currentVendor = Object.assign({}, data.customer, { email: pendingEmail });
    saveSession(currentVendor);
    document.getElementById('topbar-name').textContent = currentVendor.firstName + ' ' + currentVendor.lastName;
    showScreen('screen-app');
    showView('view-clientes');
    loadClientes();
  } catch(e) {
    err.textContent = e.message || 'Codigo incorrecto.';
    err.classList.add('visible');
    btn.disabled = false;
    btn.textContent = 'Verificar';
  }
}

function doLogout() {
  clearSession();
  currentVendor = null; allClientes = []; allProductos = []; carrito = [];
  document.getElementById('login-step-1').style.display = 'block';
  document.getElementById('login-step-2').style.display = 'none';
  document.getElementById('login-code').value = '';
  document.getElementById('btn-login').disabled = false;
  document.getElementById('btn-login').textContent = 'Enviar codigo';
  showScreen('screen-login');
}

async function loadClientes() {
  showLoading('Cargando tus clientes...');
  try {
    var res = await fetch(BACKEND + '/api/get-clients', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ _key: API_KEY, vendorEmail: currentVendor.email })
    });
    var data = await res.json();
    if (!data.ok) throw new Error(data.error);
    allClientes = data.customers;
    filteredClientes = allClientes.slice();
    renderClientes();
    var n = allClientes.length;
    document.getElementById('clientes-subtitle').textContent = n + ' cliente' + (n !== 1 ? 's' : '') + ' asignado' + (n !== 1 ? 's' : '');
  } catch(e) {
    document.getElementById('clients-grid').innerHTML = '<div class="empty-state"><p>Error cargando clientes.</p></div>';
  } finally { hideLoading(); }
}

function renderClientes() {
  var grid = document.getElementById('clients-grid');
  if (!filteredClientes.length) { grid.innerHTML = '<div class="empty-state"><p>No se encontraron clientes. Crea uno nuevo.</p></div>'; return; }
  grid.innerHTML = filteredClientes.map(function(c) {
    var descBadge = c.descuento > 0 ? '<span style="font-size:11px; background:#fff0e6; color:#FF6B00; border:1px solid #FF6B00; padding:2px 8px; border-radius:100px; font-weight:600;">Desc. ' + c.descuento + '%</span>' : '';
    return '<div class="client-card" onclick="selectCliente(\'' + c.id + '\')">' +
      '<div class="client-avatar">' + initials(c.name) + '</div>' +
      '<div class="client-name">' + c.name + '</div>' +
      '<div class="client-email">' + c.email + '</div>' +
      '<div class="client-meta"><span class="tag">Mayoreo</span>' + descBadge +
      '<button class="btn-pedido" onclick="event.stopPropagation(); selectCliente(\'' + c.id + '\')">+ Nuevo pedido</button></div>' +
      '</div>';
  }).join('');
}

function filterClientes() {
  var q = document.getElementById('search-clientes').value.toLowerCase();
  filteredClientes = allClientes.filter(function(c) { return c.name.toLowerCase().includes(q) || c.email.toLowerCase().includes(q); });
  renderClientes();
}

function showFormCliente() {
  document.getElementById('form-cliente').style.display = 'block';
  document.getElementById('nc-nombre').focus();
}

function hideFormCliente() {
  document.getElementById('form-cliente').style.display = 'none';
  ['nc-nombre','nc-apellido','nc-email','nc-telefono','nc-direccion','nc-descuento'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.value = '';
  });
  document.getElementById('form-cliente-error').classList.remove('visible');
}

async function crearCliente() {
  var firstName = document.getElementById('nc-nombre').value.trim();
  var lastName = document.getElementById('nc-apellido').value.trim();
  var email = document.getElementById('nc-email').value.trim();
  var phone = document.getElementById('nc-telefono').value.trim();
  var address = document.getElementById('nc-direccion').value.trim();
  var descuento = parseFloat(document.getElementById('nc-descuento').value) || 0;
  var err = document.getElementById('form-cliente-error');
  var btn = document.getElementById('btn-crear-cliente');
  err.classList.remove('visible');
  if (!firstName) { err.textContent = 'El nombre es obligatorio.'; err.classList.add('visible'); return; }
  if (!email && !phone) { err.textContent = 'Ingresa correo o telefono.'; err.classList.add('visible'); return; }
  btn.disabled = true;
  btn.textContent = 'Guardando...';
  try {
    var res = await fetch(BACKEND + '/api/create-client', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ _key: API_KEY, firstName: firstName, lastName: lastName, email: email, phone: phone, address: address, vendorEmail: currentVendor.email, descuento: descuento })
    });
    var data = await res.json();
    if (!data.ok) throw new Error(data.error);

    if (data.existing) {
      var existingEl = document.getElementById('form-cliente-existing');
      if (existingEl) { existingEl.style.display = 'block'; setTimeout(function() { existingEl.style.display = 'none'; }, 4000); }
    }

    var alreadyIn = allClientes.find(function(c) { return c.id === data.customer.id; });
    if (!alreadyIn) {
      allClientes.push(data.customer);
      filteredClientes = allClientes.slice();
    }
    renderClientes();
    var n = allClientes.length;
    document.getElementById('clientes-subtitle').textContent = n + ' cliente' + (n !== 1 ? 's' : '') + ' asignado' + (n !== 1 ? 's' : '');
    hideFormCliente();
  } catch(e) {
    err.textContent = e.message || 'Error al crear cliente.';
    err.classList.add('visible');
  } finally {
    btn.disabled = false;
    btn.textContent = 'Guardar cliente';
  }
}

async function selectCliente(id) {
  currentCliente = allClientes.find(function(c) { return c.id === id; });
  if (!currentCliente) return;
  carrito = [];
  document.getElementById('pedido-cliente-name').textContent = currentCliente.name;
  document.getElementById('pedido-cliente-email').textContent = currentCliente.email;
  document.getElementById('pedido-notas').value = '';
  document.getElementById('pedido-descuento').value = currentCliente.descuento || 0;
  showView('view-pedido');
  renderCarrito();
  currentPage = 1;
  await loadProductos(1);
}

function showClientes() { showView('view-clientes'); }

async function loadProductos(page) {
  page = page || 1;
  showLoading('Cargando inventario...');
  try {
    var res = await fetch(BACKEND + '/api/get-products', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body: JSON.stringify({ _key: API_KEY, page: page })
    });
    var data = await res.json();
    if (!data.ok) throw new Error(data.error);

    var newProducts = data.products.map(function(p) {
      return Object.assign({}, p, {
        variants: p.variants.map(function(v) {
          return Object.assign({}, v, {
            price: Math.round(v.price * 0.602 * 10) / 10
          });
        })
      });
    });

    if (page === 1) {
      allProductos = newProducts;
    } else {
      allProductos = allProductos.concat(newProducts);
    }

    currentPage = data.pagination.page;
    totalPages = data.pagination.totalPages;

    var cats = allProductos.map(function(p) { return p.category; }).filter(function(v, i, a) { return a.indexOf(v) === i; }).sort();
    var sel = document.getElementById('filter-categoria');
    var currentCat = sel.value;
    sel.innerHTML = '<option value="">Todas las categorias</option>' + cats.map(function(c) { return '<option value="' + c + '">' + c + '</option>'; }).join('');
    sel.value = currentCat;

    filteredProductos = allProductos.slice();
    renderProductos();

    var btnVerMas = document.getElementById('btn-ver-mas');
    if (btnVerMas) {
      btnVerMas.style.display = data.pagination.hasMore ? 'block' : 'none';
      btnVerMas.disabled = false;
      btnVerMas.textContent = 'Ver mas productos';
    }
  } catch(e) {
    console.error('[loadProductos]', e);
    document.getElementById('productos-tbody').innerHTML = '<tr><td colspan="4" style="text-align:center; padding:2rem; color:var(--danger);">Error cargando productos.</td></tr>';
  } finally { hideLoading(); }
}

async function cargarMas() {
  var btn = document.getElementById('btn-ver-mas');
  if (btn) { btn.disabled = true; btn.textContent = 'Cargando...'; }
  await loadProductos(currentPage + 1);
}

// ════════════════════════════════════════════════════════════
// RENDER DE PRODUCTOS — 4 columnas: Producto | SKU/Precio | Variante | Acciones
// ════════════════════════════════════════════════════════════
function renderProductos() {
  var tbody = document.getElementById('productos-tbody');
  var count = document.getElementById('productos-count');
  if (!filteredProductos.length) {
    tbody.innerHTML = '<tr><td colspan="4" style="text-align:center; padding:2rem; color:var(--text-muted);">Sin resultados</td></tr>';
    count.textContent = ''; return;
  }
  count.textContent = 'Mostrando ' + filteredProductos.length + ' productos';
  tbody.innerHTML = filteredProductos.map(function(p) {
    var safeId = p.id.replace(/\//g, '-');

    function accionesHTML(maxStock, disabled, onclickAttr) {
      return '<td class="td-acciones"><div class="td-acciones-inner">' +
        '<input type="text" class="comentario-input" placeholder="Comentario..." id="com-' + safeId + '" ' + disabled + '>' +
        '<div class="qty-btn-row">' +
        '<input class="qty-input" type="number" min="1" max="' + maxStock + '" value="1" id="qty-' + safeId + '" ' + disabled + '>' +
        '<button class="btn-add" id="btn-' + safeId + '" ' + onclickAttr + ' ' + disabled + '>+ Agregar</button>' +
        '</div></div></td>';
    }

    if (!p.hasVariants) {
      var v = p.variants[0];
      var dis = v.stock === 0 ? 'disabled' : '';
      var agotadoTag = v.stock === 0 ? ' <span class="agotado-tag">Agotado</span>' : '';
      return '<tr>' +
        '<td class="td-titulo">' + p.title + '</td>' +
        '<td class="td-sku-precio"><span class="td-sku" id="sku-' + safeId + '">' + v.sku + '</span><span class="td-precio" id="precio-' + safeId + '">' + fmt(v.price) + agotadoTag + '</span></td>' +
        '<td class="td-variante">—</td>' +
        accionesHTML(v.stock, dis, 'onclick="addToCart(\'' + p.id + '\', \'' + v.id + '\')"') +
        '</tr>';
    } else {
      var variantOptions = p.variants.map(function(v) {
        return '<option value="' + v.id + '" data-price="' + v.price + '" data-stock="' + v.stock + '" data-sku="' + v.sku + '" ' + (v.stock === 0 ? 'disabled' : '') + '>' +
          v.title + (v.stock === 0 ? ' (Agotado)' : '') + '</option>';
      }).join('');
      var firstAvailable = p.variants.find(function(v) { return v.stock > 0; });
      var defStock = firstAvailable ? firstAvailable.stock : 0;
      var v0 = p.variants[0];
      var agotadoTag0 = v0.stock === 0 ? ' <span class="agotado-tag">Agotado</span>' : '';

      return '<tr>' +
        '<td class="td-titulo">' + p.title + '</td>' +
        '<td class="td-sku-precio"><span class="td-sku" id="sku-' + safeId + '">' + v0.sku + '</span><span class="td-precio" id="precio-' + safeId + '">' + fmt(v0.price) + agotadoTag0 + '</span></td>' +
        '<td class="td-variante"><select id="var-' + safeId + '" onchange="updateVariantInfo(\'' + safeId + '\')">' + variantOptions + '</select></td>' +
        accionesHTML(defStock, defStock === 0 ? 'disabled' : '', 'onclick="addToCartVariant(\'' + p.id + '\', \'' + safeId + '\')"') +
        '</tr>';
    }
  }).join('');
}

function updateVariantInfo(safeId) {
  var sel = document.getElementById('var-' + safeId);
  var opt = sel.options[sel.selectedIndex];
  var price = parseFloat(opt.getAttribute('data-price'));
  var stock = parseInt(opt.getAttribute('data-stock'));
  var sku   = opt.getAttribute('data-sku');

  var qtyEl    = document.getElementById('qty-' + safeId);
  var btnEl    = document.getElementById('btn-' + safeId);
  var comEl    = document.getElementById('com-' + safeId);
  var skuEl    = document.getElementById('sku-' + safeId);
  var precioEl = document.getElementById('precio-' + safeId);

  if (skuEl) skuEl.textContent = sku;
  if (precioEl) {
    precioEl.innerHTML = fmt(price) + (stock === 0 ? ' <span class="agotado-tag">Agotado</span>' : '');
  }

  qtyEl.max = stock;
  qtyEl.value = 1;
  qtyEl.disabled = stock === 0;
  btnEl.disabled = stock === 0;
  if (comEl) comEl.disabled = stock === 0;
}

function normalizar(str) {
  return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function filterProductos() {
  var q = document.getElementById('search-productos').value.trim();
  var cat = document.getElementById('filter-categoria').value;

  if (q.length === 0) {
    filteredProductos = allProductos.filter(function(p) {
      return !cat || p.category === cat;
    });
    renderProductos();
    var btnVerMas = document.getElementById('btn-ver-mas');
    if (btnVerMas) btnVerMas.style.display = currentPage < totalPages ? 'block' : 'none';
  } else {
    clearTimeout(window._searchTimer);
    window._searchTimer = setTimeout(async function() {
      showLoading('Buscando...');
      try {
        var res = await fetch(BACKEND + '/api/get-products', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ _key: API_KEY, page: 1, search: q })
        });
        var data = await res.json();
        if (!data.ok) throw new Error(data.error);
        filteredProductos = data.products.map(function(p) {
          return Object.assign({}, p, {
            variants: p.variants.map(function(v) {
              return Object.assign({}, v, {
                price: Math.round(v.price * 0.602 * 10) / 10
              });
            })
          });
        });
        if (cat) filteredProductos = filteredProductos.filter(function(p) { return p.category === cat; });

        var totalPgs = data.pagination.totalPages;
        var pg = 2;
        while (pg <= totalPgs) {
          var res2 = await fetch(BACKEND + '/api/get-products', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ _key: API_KEY, page: pg, search: q })
          });
          var data2 = await res2.json();
          if (!data2.ok) break;
          var more = data2.products.map(function(p) {
            return Object.assign({}, p, {
              variants: p.variants.map(function(v) {
                return Object.assign({}, v, { price: Math.round(v.price * 0.602 * 10) / 10 });
              })
            });
          });
          if (cat) more = more.filter(function(p) { return p.category === cat; });
          filteredProductos = filteredProductos.concat(more);
          pg++;
        }

        renderProductos();
        var btnVerMas = document.getElementById('btn-ver-mas');
        if (btnVerMas) btnVerMas.style.display = 'none';
      } catch(e) {
        console.error(e);
      } finally { hideLoading(); }
    }, 400);
  }
}

function addToCart(productId, variantId) {
  var producto = allProductos.find(function(p) { return p.id === productId; }) ||
               filteredProductos.find(function(p) { return p.id === productId; });
  var variant = producto.variants.find(function(v) { return v.id === variantId; });
  var safeId = productId.replace(/\//g, '-');
  var qtyEl = document.getElementById('qty-' + safeId);
  var comEl = document.getElementById('com-' + safeId);
  var qty = parseInt(qtyEl ? qtyEl.value : 1);
  var comentario = comEl ? comEl.value.trim() : '';
  if (!producto || !variant || qty < 1) return;
  var cartKey = productId + '_' + variantId;
  var existing = carrito.find(function(i) { return i.cartKey === cartKey; });
  if (existing) {
    existing.qty = Math.min(existing.qty + qty, variant.stock);
    if (comentario) existing.comentario = comentario;
  } else {
    carrito.push({ cartKey: cartKey, id: productId, variantId: variantId, title: producto.title, variantTitle: '', sku: variant.sku, price: variant.price, stock: variant.stock, qty: qty, comentario: comentario, image: producto.image || null });
  }
  if (qtyEl) qtyEl.value = 1;
  if (comEl) comEl.value = '';
  renderCarrito();
}

function addToCartVariant(productId, safeId) {
  var producto = allProductos.find(function(p) { return p.id === productId; }) ||
               filteredProductos.find(function(p) { return p.id === productId; });
  var sel = document.getElementById('var-' + safeId);
  var variantId = sel.value;
  var variant = producto.variants.find(function(v) { return v.id === variantId; });
  var qtyEl = document.getElementById('qty-' + safeId);
  var comEl = document.getElementById('com-' + safeId);
  var qty = parseInt(qtyEl ? qtyEl.value : 1);
  var comentario = comEl ? comEl.value.trim() : '';
  if (!variant || qty < 1) return;
  var cartKey = productId + '_' + variantId;
  var existing = carrito.find(function(i) { return i.cartKey === cartKey; });
  if (existing) {
    existing.qty = Math.min(existing.qty + qty, variant.stock);
    if (comentario) existing.comentario = comentario;
  } else {
    carrito.push({ cartKey: cartKey, id: productId, variantId: variantId, title: producto.title, variantTitle: variant.title, sku: variant.sku, price: variant.price, stock: variant.stock, qty: qty, comentario: comentario, image: producto.image || null });
  }
  if (qtyEl) qtyEl.value = 1;
  if (comEl) comEl.value = '';
  renderCarrito();
}

function removeFromCart(cartKey) {
  carrito = carrito.filter(function(i) { return i.cartKey !== cartKey; });
  renderCarrito();
}

function renderCarrito() {
  var container = document.getElementById('carrito-items');
  var totalSection = document.getElementById('carrito-total');
  var btn = document.getElementById('btn-confirmar');
  if (!carrito.length) {
    container.innerHTML = '<div class="carrito-empty">El carrito esta vacio.<br>Agrega productos desde la lista.</div>';
    totalSection.style.display = 'none'; btn.disabled = true; return;
  }
  var total = carrito.reduce(function(s, i) { return s + i.price * i.qty; }, 0);
  container.innerHTML = carrito.map(function(i) {
    var displayTitle = i.variantTitle ? i.title + ' — ' + i.variantTitle : i.title;
    return '<div class="carrito-item">' +
      '<div class="carrito-item-info">' +
      '<div class="carrito-item-name">' + displayTitle + '</div>' +
      '<div class="carrito-item-sku">' + i.sku + ' · qty: ' + i.qty + '</div>' +
      (i.comentario ? '<div class="carrito-item-sku" style="color:var(--accent); font-style:italic;">Nota: ' + i.comentario + '</div>' : '') +
      '<div class="carrito-item-price">' + fmt(i.price) + ' c/u</div>' +
      '</div>' +
      '<div class="carrito-item-right">' +
      '<button class="btn-remove" onclick="removeFromCart(\'' + i.cartKey + '\')">x</button>' +
      '<div class="carrito-item-total">' + fmt(i.price * i.qty) + '</div>' +
      '</div></div>';
  }).join('');
  var descuentoPct = parseFloat(document.getElementById('pedido-descuento').value) || 0;
  var descuentoAmt = total * (descuentoPct / 100);
  var subtotalConDescuento = total - descuentoAmt;
  var iva = subtotalConDescuento * 0.16;
  var totalConIva = subtotalConDescuento + iva;
  document.getElementById('total-amount').textContent = fmt(total);
  document.getElementById('descuento-amount').textContent = '-' + fmt(descuentoAmt);
  document.getElementById('iva-amount').textContent = fmt(iva);
  document.getElementById('total-con-iva').textContent = fmt(totalConIva);
  totalSection.style.display = 'block'; btn.disabled = false;
}

async function confirmarPedido() {
  if (!carrito.length || !currentCliente) return;
  var btn = document.getElementById('btn-confirmar');
  btn.disabled = true;
  btn.textContent = 'Enviando...';
  showLoading('Enviando pedido...');
  var folio = genFolio();
  var notas = document.getElementById('pedido-notas').value.trim();
  var total = carrito.reduce(function(s, i) { return s + i.price * i.qty; }, 0);
  var descuentoPct = parseFloat(document.getElementById('pedido-descuento').value) || 0;
  var descuentoAmt = total * (descuentoPct / 100);
  var totalConDescuento = total - descuentoAmt;
  var totalConIva = totalConDescuento * 1.16;
  var fecha = new Date().toLocaleDateString('es-MX', { year:'numeric', month:'long', day:'numeric' });

  var productosParaEnviar = carrito.map(function(i) {
    return { title: i.variantTitle ? i.title + ' — ' + i.variantTitle : i.title, sku: i.sku, qty: i.qty, price: i.price, comentario: i.comentario || '', image: i.image || null };
  });

  var pedidoData = {
    folio: folio,
    productos: productosParaEnviar,
    cliente: { name: currentCliente.name, email: currentCliente.email, phone: currentCliente.phone || '', address: currentCliente.address || '' },
    subtotal: total.toFixed(2),
    descuentoPct: descuentoPct,
    descuentoAmt: descuentoAmt.toFixed(2),
    total: totalConDescuento.toFixed(2),
    totalConIva: totalConIva.toFixed(2)
  };

  try {
    await fetch(BACKEND + '/api/send-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({_key: API_KEY,
        folio: folio,
        fecha: fecha,
        vendedor: currentVendor.firstName + ' ' + currentVendor.lastName,
        cliente: pedidoData.cliente,
        productos: productosParaEnviar,
        subtotal: pedidoData.subtotal,
        descuentoPct: descuentoPct,
        descuentoAmt: pedidoData.descuentoAmt,
        total: pedidoData.total,
        totalConIva: pedidoData.totalConIva,
        notas: notas
      })
    });

    document.getElementById('confirm-folio').textContent = folio;
    document.getElementById('confirm-details').innerHTML =
      '<strong>Cliente:</strong> ' + currentCliente.name + '<br>' +
      '<strong>Fecha:</strong> ' + fecha + '<br>' +
      '<strong>Productos:</strong> ' + carrito.length + ' articulo' + (carrito.length !== 1 ? 's' : '') + '<br>' +
      '<strong>Total con IVA:</strong> $' + totalConIva.toFixed(2) + '<br>' +
      (notas ? '<strong>Notas:</strong> ' + notas : '');

    await fetch(BACKEND + '/api/save-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ _key: API_KEY,
        vendorEmail: currentVendor.email,
        pedido: {
          folio: folio,
          fecha: fecha,
          cliente: pedidoData.cliente,
          productos: productosParaEnviar,
          subtotal: pedidoData.subtotal,
          descuentoPct: descuentoPct,
          descuentoAmt: pedidoData.descuentoAmt,
          total: pedidoData.total,
          totalConIva: pedidoData.totalConIva,
          notas: notas
        }
      })
    });

    carrito = [];
    document.getElementById('btn-descargar-excel').onclick = function() { descargarExcel(pedidoData); };
    document.getElementById('btn-descargar-excel').style.display = 'inline-block';
    showScreen('screen-confirm');
  } catch(e) {
    btn.disabled = false; btn.textContent = 'Confirmar pedido';
    alert('Error al enviar el pedido. Intenta de nuevo.');
  } finally { hideLoading(); }
}

function descargarExcel(pedidoData) {
  var rows = [
    ['PEDIDO MAYOREO KIKOMO'],
    [],
    ['Folio', pedidoData.folio],
    ['Fecha', new Date().toLocaleDateString('es-MX')],
    ['Cliente', pedidoData.cliente.name],
    ['Correo', pedidoData.cliente.email],
    ['Telefono', pedidoData.cliente.phone || ''],
    ['Direccion', pedidoData.cliente.address || ''],
    [],
    ['SKU', 'Cantidad', 'Producto', 'Nota', 'Precio unitario', 'Subtotal']
  ];
  pedidoData.productos.forEach(function(p) {
    rows.push([p.sku, p.qty, p.title, p.comentario || '', p.price, p.price * p.qty]);
  });
  rows.push([]);
  rows.push(['', '', '', '', 'Subtotal', parseFloat(pedidoData.subtotal)]);
  if (pedidoData.descuentoPct > 0) {
    rows.push(['', '', '', '', 'Descuento (' + pedidoData.descuentoPct + '%)', -parseFloat(pedidoData.descuentoAmt)]);
  }
  rows.push(['', '', '', '', 'IVA (16%)', parseFloat(pedidoData.total) * 0.16]);
  rows.push(['', '', '', '', 'TOTAL CON IVA', parseFloat(pedidoData.totalConIva)]);

  var ws = XLSX.utils.aoa_to_sheet(rows);
  ws['!cols'] = [{ wch: 15 }, { wch: 10 }, { wch: 45 }, { wch: 25 }, { wch: 18 }, { wch: 14 }];
  var wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Pedido');
  XLSX.writeFile(wb, 'Pedido-' + pedidoData.folio + '.xlsx');
}

function nuevoPedido() {
  showScreen('screen-app'); showView('view-clientes');
  document.getElementById('btn-confirmar').disabled = false;
  document.getElementById('btn-confirmar').textContent = 'Confirmar pedido';
  document.getElementById('btn-descargar-excel').style.display = 'none';
}

async function showHistorial() {
  showView('view-historial');
  document.getElementById('historial-lista').innerHTML = '<div class="empty-state"><p>Cargando pedidos...</p></div>';
  document.getElementById('historial-detalle').style.display = 'none';
  try {
    var res = await fetch(BACKEND + '/api/get-orders', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ _key: API_KEY, vendorEmail: currentVendor.email })
    });
    var data = await res.json();
    if (!data.ok) throw new Error(data.error);
    var pedidos = data.pedidos;
    document.getElementById('historial-subtitle').textContent = pedidos.length + ' pedido' + (pedidos.length !== 1 ? 's' : '');
    if (!pedidos.length) {
      document.getElementById('historial-lista').innerHTML = '<div class="empty-state"><p>No hay pedidos aun.</p></div>';
      return;
    }
    document.getElementById('historial-lista').innerHTML = pedidos.map(function(p, idx) {
      return '<div class="pedido-section" style="cursor:pointer; margin-bottom:0.75rem;" onclick="verDetalle(' + idx + ')">' +
        '<div style="display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:0.5rem;">' +
        '<div>' +
        '<div style="font-weight:700; color:var(--brand); font-size:15px;">' + p.folio + '</div>' +
        '<div style="font-size:13px; color:var(--text-muted);">' + p.fecha + ' · ' + p.cliente.name + '</div>' +
        '<div style="font-size:13px; color:var(--text-muted);">' + p.productos.length + ' producto' + (p.productos.length !== 1 ? 's' : '') + '</div>' +
        '</div>' +
        '<div style="text-align:right;">' +
        '<div style="font-weight:700; font-size:16px; color:var(--brand);">$' + p.totalConIva + '</div>' +
        '<div style="font-size:11px; color:var(--text-muted);">Total con IVA</div>' +
        '</div></div></div>';
    }).join('');
    window._pedidosHistorial = pedidos;
  } catch(e) {
    document.getElementById('historial-lista').innerHTML = '<div class="empty-state"><p>Error cargando pedidos.</p></div>';
  }
}

function verDetalle(idx) {
  var p = window._pedidosHistorial[idx];
  if (!p) return;
  document.getElementById('historial-lista').style.display = 'none';
  document.getElementById('historial-detalle').style.display = 'block';
  document.getElementById('detalle-folio').textContent = p.folio;
  document.getElementById('detalle-info').innerHTML =
    '<strong>Fecha:</strong> ' + p.fecha + '<br>' +
    '<strong>Cliente:</strong> ' + p.cliente.name + '<br>' +
    '<strong>Correo:</strong> ' + p.cliente.email + '<br>' +
    (p.cliente.phone ? '<strong>Telefono:</strong> ' + p.cliente.phone + '<br>' : '') +
    (p.notas ? '<strong>Notas:</strong> ' + p.notas + '<br>' : '');
  document.getElementById('detalle-productos').innerHTML = p.productos.map(function(prod) {
    return '<tr>' +
      '<td style="font-weight:500;">' + prod.title + '</td>' +
      '<td style="color:var(--text-muted); font-size:12px;">' + prod.sku + '</td>' +
      '<td style="text-align:center;">' + prod.qty + '</td>' +
      '<td style="color:#888; font-style:italic;">' + (prod.comentario || '-') + '</td>' +
      '<td style="text-align:right; font-weight:600;">$' + (prod.price * prod.qty).toFixed(2) + '</td>' +
      '</tr>';
  }).join('');
  var descRow = p.descuentoPct > 0 ? '<tr><td colspan="4" style="text-align:right; color:#c0392b;">Descuento (' + p.descuentoPct + '%):</td><td style="text-align:right; color:#c0392b;">-$' + p.descuentoAmt + '</td></tr>' : '';
  document.getElementById('detalle-totales').innerHTML =
    '<tr style="background:#f9f7f3;"><td colspan="4" style="text-align:right; padding:8px;">Subtotal:</td><td style="text-align:right; padding:8px;">$' + p.subtotal + '</td></tr>' +
    descRow +
    '<tr style="background:#f9f7f3;"><td colspan="4" style="text-align:right; padding:8px;">IVA (16%):</td><td style="text-align:right; padding:8px;">$' + (parseFloat(p.total) * 0.16).toFixed(2) + '</td></tr>' +
    '<tr style="background:#f9f7f3; font-weight:700;"><td colspan="4" style="text-align:right; padding:8px;">Total con IVA:</td><td style="text-align:right; padding:8px; color:var(--brand);">$' + p.totalConIva + '</td></tr>';
}

function cerrarDetalle() {
  document.getElementById('historial-detalle').style.display = 'none';
  document.getElementById('historial-lista').style.display = 'block';
}